import { useContext } from 'react'

import { Text } from '@hhgtech/hhg-components/mantine'
import { Skeleton } from '@mantine/core'
import dayjs from 'dayjs'
import { useIntl } from 'react-intl'

import { AirPopulationContext } from '../context'

export const TimeStatus = () => {
  const { firstLoading, data } = useContext(AirPopulationContext)
  const { updatedTime } = data || {}
  const { formatMessage: f } = useIntl()
  if (firstLoading)
    return <Skeleton sx={{ marginTop: 6 }} height={12} radius={4} width={120} />
  return (
    <Text size="p3" variant="tertiary">
      {f(
        {
          id: 'airPopulation.timeUpdate',
          defaultMessage: '{time} Update every {from} - {to}h',
        },
        {
          time: dayjs(updatedTime).format('HH:mm'),
          from: 1,
          to: 2,
        },
      )}
    </Text>
  )
}
